module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Gaechlingen-bf4ce04f01ddf54d114795aa58c9597a.png";